import React from 'react';

import { Spinner } from 'components/ui/spinner';

import { TableCell, TableRow } from '../../ui';
import { IInfiniteScrollIndicatorProps } from '../DataTable.types';

export const InfiniteScrollIndicator: React.FC<
  IInfiniteScrollIndicatorProps
> = ({ columnsCount, loadMoreRef, isLoadingMore, hasMore, enabled }) => {
  if (!enabled) {
    return null;
  }

  if (isLoadingMore) {
    return (
      <TableRow>
        <TableCell colSpan={columnsCount} className="text-center py-4 border-t">
          <Spinner className="size-7" />
        </TableCell>
      </TableRow>
    );
  }

  if (hasMore) {
    return (
      <TableRow>
        <TableCell colSpan={columnsCount} className="text-center py-2 border-t">
          <div
            ref={loadMoreRef}
            style={{ height: '1px', visibility: 'hidden' }}
          />
        </TableCell>
      </TableRow>
    );
  }

  return null;
};
